import * as Oidc from "oidc-client-ts";

let userManager: Oidc.UserManager;

const state = {
  isUserSignedIn: false,
  isDialogShown: false,
  title: "",
  content: "",
};

let baseUrl = `${window.location.origin}`;
let signInredirectUri =
  baseUrl + "/" + process.env.REACT_APP_AZURE_SIGNIN_CALLBACK;
let signOutredirectUri =
  baseUrl + "/" + process.env.REACT_APP_AZURE_SIGNOUT_CALLBACK;

const settings: Oidc.UserManagerSettings = {
  authority: process.env.REACT_APP_AZURE_AUTHORITY ?? "",
  client_id: process.env.REACT_APP_AZURE_CLIENTID ?? "",
  redirect_uri: signInredirectUri,
  post_logout_redirect_uri: signOutredirectUri,
  revokeTokensOnSignout: true,
  response_type: process.env.REACT_APP_AZURE_RESPONSE_TYPE,
  scope: "openid profile offline_access cogcache.identity.main",
  accessTokenExpiringNotificationTimeInSeconds: 30,
  automaticSilentRenew: false,
  userStore: new Oidc.WebStorageStateStore({ store: window.localStorage }),
};

userManager = new Oidc.UserManager(settings);

if (String(window.location.hostname) === "localhost") {
  Oidc.Log.setLevel(Oidc.Log.DEBUG);
  Oidc.Log.setLogger(console);
}

const signinRedirect = async (
  returnUrl: string,
  queryParams?: Record<string, string | number | boolean>,
  token?: string | null,
) => {
  try {
    let extraQueryParams = {
      ...queryParams,
    };
    if (token) {
      extraQueryParams = {
        autoSignIn: true,
        azureToken: token,
      };
    }
    await userManager.signinRedirect({
      state: {
        returnUrl,
        token,
      },
      extraQueryParams: extraQueryParams,
    });
  } catch (error: any) {
    console.log("signinRedirect");
    console.log(error);
  }
};

const refreshTokenAsync = async (): Promise<Oidc.User | null> => {
  try {
    const res = await userManager.signinSilent();
    return res;
  } catch (error: any) {
    onSilentRenewError();
    return null;
  }
};

const onSilentRenewError = () => {
  console.log("onUserManagerSilentRenewError");
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  userManager.removeUser();
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  userManager.signinRedirect();
};

export { refreshTokenAsync, settings, signinRedirect, state, userManager };
